module.exports = __webpack_public_path__ + "static/PartnerStampRed-969840911a048a26f3f6807c6ae1006e.png";